import styled from 'styled-components'
import { FlexContainer } from '../../layouts'
import { Button } from '../../components'
import { colors } from '../../styles'

export const StyledGraphicHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const PublishedGraphicWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const InteractiveGraphicWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    flex-grow: 1;
  }
`
export const CopyLinkButton = styled(Button)`
  padding: 8px 12px;
  width: 128px;
`

export const CopyLynxEditorLinkButton = styled(Button)`
  padding: 8px 12px;
  width: 210px;
`

export const ActionsContainer = styled(FlexContainer)`
  justify-content: space-between;
`

export const OrangeText = styled.span`
  color: ${colors.portal};
`
